const tenants = {

  install (Vue, options) {
    Vue.prototype.Tenants = {
      CLINIC: 'Clinic',
      MEDICAL_CENTER: 'MedicalCenter'
    }
  }
}

export default tenants



// WEBPACK FOOTER //
// ./src/constants/tenants.js